import { render } from "./right-sidebar.vue?vue&type=template&id=1474b20e"
import script from "./right-sidebar.vue?vue&type=script&lang=js"
export * from "./right-sidebar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dereklei/Documents/DotnetProjects/WorkProjects/OAuth.Server.OneId/OAuth.Server/Web/Saas.Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__